import s from 'styled-components';

const SectHeader = s.h2`
  color: var(--font-color-emp);
  position: relative;
  font-weight: 300;
  text-align: center;
  font-size: 30px;
  margin: 15px 0;
  margin-bottom: 25px;
`
export default SectHeader;